import type { ReactNode } from "react";
import cx from "ui/cx";
import styles from "./InputLabel.module.scss";

interface InputLabelProps {
  text: ReactNode;
  required?: boolean;
  className?: string;
}

export default function InputLabel({ text, required = false, className }: InputLabelProps) {
  return <div className={cx({ styles, wrapper: true, required }, className)}>{text}</div>;
}
